// Bucket labels for display in the UI
export const BUCKET_LABELS = {
  NEW_LISTINGS: "New Listings",
  MOMENTUM: "Momentum",
  TRENDING_SOCIAL: "Trending Social",
  FUNDING_RATE_ANOMALY: "Funding Rate Anomaly",
  VOLUME_BREAKOUT: "Volume Breakout",
  WHALE_ACTIVITY: "Whale Activity",
  SECTOR_ROTATION: "Sector Rotation",
  CORRELATION_DIVERGENCE: "Correlation Divergence",
  LIQUIDATION_CLUSTERS: "Liquidation Clusters",
};

// Bucket descriptions for tooltips/help text
export const BUCKET_DESCRIPTIONS = {
  NEW_LISTINGS: "Recently added perpetuals on Hyperliquid",
  MOMENTUM: "Strong directional price movement across multiple timeframes",
  TRENDING_SOCIAL: "Tokens gaining attention on social media and news",
  FUNDING_RATE_ANOMALY: "Unusually high or low funding rates indicating overcrowded positioning",
  VOLUME_BREAKOUT: "Volume spiking relative to recent rolling average",
  WHALE_ACTIVITY: "Large position changes or whale wallet movements",
  SECTOR_ROTATION: "Hot/cold sector identification across L1, DeFi, AI, and more",
  CORRELATION_DIVERGENCE: "Tokens decoupling from BTC/ETH correlation patterns",
  LIQUIDATION_CLUSTERS: "Concentrated liquidation risk levels on the exchange",
};
